import React, { useId } from "react";
import { Button } from "react-bootstrap";
import { clock } from "./clock";

// docs/specs/mfa-ux-cleanup.md §2 (Row 0, option A): on the email/SMS code step, say why SSN/TIN and what comes
// next, then offer it as a real button. While Oracle still holds TIN back (`tinWaitSeconds` > 0) a countdown line
// stands in for the button. Presentational: `onSelect("tin")` is useMfaLogin.selectMethod.
const COPY = {
  email: {
    heading: "Didn't get the email?",
    first: "Check your spam folder, or resend the code.",
    after: "so you won't need email codes again.",
  },
  sms: {
    heading: "Didn't get the text?",
    first: "Resend the code.",
    after: "so you won't need text codes again.",
  },
};

// docs/specs/login-setup.md §3: `setupRequired` (login/start, LOGIN_SETUP on only) holding phone adds that step.
export const nextSteps = (setupRequired) =>
  setupRequired?.includes("phone")
    ? "confirm your mobile number and set up an authenticator app"
    : "set up an authenticator app";

const TinOfferBox = ({ method, tinWaitSeconds, onSelect, disabled, setupRequired }) => {
  const headingId = useId();
  const copy = COPY[method] ?? COPY.email;
  return (
    <section className="mfa-tin-offer" aria-labelledby={headingId}>
      <h4 id={headingId}>{copy.heading}</h4>
      <p>
        {`${copy.first} Still nothing? Confirm it's you with the last 4 digits of the SSN or TIN on your loan. `}
        {`Then you'll ${nextSteps(setupRequired)}, ${copy.after}`}
      </p>
      {tinWaitSeconds > 0 ? (
        <p className="mfa-tin-wait">{`You can verify with your SSN or TIN in ${clock(tinWaitSeconds)}.`}</p>
      ) : (
        <Button variant="outline-dark" type="button" className="fw-semibold" disabled={disabled} onClick={() => onSelect("tin")}>
          Verify with SSN/TIN instead
        </Button>
      )}
    </section>
  );
};

export default TinOfferBox;
